import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useState, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Grid,Box } from '@material-ui/core';
// import './flight.css'
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedFormData, setSelectSeat } from '../../reducers/UiReducer';
import { useLocation } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenSeat({formData,items}) {
  const [open, setOpen] = React.useState(false);
  const {ssrTBO} = useSelector((state)=>state.home)
  const [selectedSeat, setSelectedSeat] = useState({});
  const location = useLocation();
  console.log("formData",formData)
  const dispatch = useDispatch();
  const [condition, setCondition] = useState(false);
	const [seat, setSeat] = useState();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleChange = (e) => {
		let { name, checked, type } = e.target;
		console.log('name', name);
		console.log('checked', checked);
		console.log('type', type);
		setSelectedSeat({
      // ...selectedSeat,
      [name]: (type = 'checkbox' ? checked : ''),
    });
	};
  let selectSeat = [];
  
	if (seat && seat.length > 0 && ssrTBO) {
	items?.RowSeats?.map((i) => {
      i.Seats.map((s)=>{
        seat.map((it)=>{
          if(it===s.Code){
            // dispatch(setSelectSeat(s))
            selectSeat.push({
              ...s
            })
          }
        })
      })
			});
	}
	console.log('selectSeat', selectSeat);
  const handleClose = () => {
    setOpen(false);
    dispatch(setSelectedFormData(formData))
  };
  useEffect(() => {
		for (let x in selectedSeat) {
      console.log("selectedSeat[x]",selectedSeat[x])
			if (selectedSeat[x] === false) {
				setCondition(false);
				continue;
			} else {
				setCondition(true);
				break;
			}
		}

		const a = [];
		for (let y in selectedSeat) {
      console.log("y",y)
			if (selectedSeat[y] == false) {
				continue;
			} else {
				a.push(y);
			}
		}
    
		setSeat(a);
    dispatch(setSelectSeat(a))
	}, [selectedSeat]);
  console.log("seat",seat)
  console.log("selectedSeat",selectedSeat)

  return (
    <div style={{boxShadow: 'rgb(0 0 0 / 15%) 0px 0.5rem 1rem',
    background: 'white',
    padding: '10px',
    marginTop: '10px'
}}>
      <Button variant="outlined" onClick={handleClickOpen}>
        Select Seat
      </Button>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {`Seat Selection ${items.RowSeats[0].Seats[0].Origin}-${items.RowSeats[0].Seats[0].Destination}`}
            </Typography>
            <Button autoFocus color="inherit" onClick={handleClose}>
              Done
            </Button>
          </Toolbar>
        </AppBar>
       <Grid container style={{alignItems:'baseline'}} >
        <Grid item xs={1}></Grid>
        <Grid item xs={12} lg={3} style={{paddingLeft:20}} >
          <Box>
            <h4>Pax Details</h4>
          </Box>
         
           {formData?.map((i)=>{
            return (
              <>
               <Box style={{background:'aliceblue',padding:'20px',marginTop:10}}>
               <span style={{fontWeight:'bold'}}> {`${i.title} ${i.firstname} ${i.lastname}`}</span>
            <Box>
              {/* <span>DEL - CCU</span><br></br> */}
              <span style={{fontWeight:'bold'}}>{`${i.seat?.Code?i.seat?.Code:'_'}, ₹${i.seat?.Price?i.seat?.Price:'_'}`}</span><br></br>
              {/* <span>₹6544</span><br></br> */}
            </Box>
          </Box>

              </>
            )
           })}
        </Grid>
        <Grid item xs={12} lg={8}>
        <div class="plane">
  <div class="cockpit">
    <h1>Please select a seat</h1>
  </div>
  <div class="exit exit--front fuselage">
    
  </div>
  <ol class="cabin fuselage">
    {items?.RowSeats?.map((i,index)=>{
      return  <li class="row row--1">
      <ol class="seats" type="A">
        {
          index>0?i.Seats.map((item,index)=>{
            return <li class="seatss">
            <input type="checkbox" onChange={handleChange} name={item.Code} value='fl' id={`checkbox-id${item.Code}`}  disabled={item.AvailablityType===1?false:true}   />
            <label for={`checkbox-id${item.Code}`} title={`₹${item.Price}`} >{item.Code}</label>
            {/* <br></br><span style={{fontSize:11}}>₹{item.Price}</span> */}
            {/* <label for={`checkbox-id${item.Code}`} >₹{item.Price}</label> */}
          </li>
          }):''
        }
      </ol>
    </li>
    })}
   
  </ol>
  <div class="exit exit--back fuselage">
    
  </div>
</div>
        </Grid>
       </Grid>
      </Dialog>
    </div>
  );
}
